import { useAuth } from '@/hooks/useAuth';
import { useAuthQuery } from '@/hooks/useAuthQuery';
import { useAdminCheck } from '@/hooks/useAdminCheck';
import { logger } from '@/lib/logger';

/**
 * P&L Module Permission Hooks
 * Light QA Contract compliant - follows Collection pattern
 */

const useOptimizedPermissionCheck = (permissionCode: string, projectId?: string) => {
  const { user } = useAuth();
  
  return useAuthQuery<boolean>({
    queryKey: ['pl-permissions', user?.id, projectId, permissionCode],
    queryFn: async () => {
      const { checkUserPermission } = await import('@/lib/queries/authQueries');
      const result = await checkUserPermission(user?.id || '', permissionCode);
      logger.debug('[PL Permissions]', { permissionCode, result });
      return result;
    },
    requiresAuth: true,
    requiresSession: true,
    enabled: !!permissionCode && !!user?.id,
    staleTime: 60 * 1000,
    gcTime: 30 * 1000,
    refetchOnMount: true,
    
  });
};

// Base access check - dùng cho visibility của tab
export const usePLAccess = (projectId?: string) => {
  const { isAdmin, isLoading: isAdminLoading } = useAdminCheck();
  const permissionCheck = useOptimizedPermissionCheck('PL_ACCESS', projectId);
  
  // Admin override - admin luôn có quyền
  return {
    data: isAdmin || permissionCheck.data,
    isLoading: isAdminLoading || permissionCheck.isLoading
  };
};

// View permissions
export const usePLViewPermissions = (projectId?: string) => {
  return useOptimizedPermissionCheck('PL_VIEW', projectId);
};

// Export permissions
export const usePLExportPermissions = (projectId?: string) => {
  return useOptimizedPermissionCheck('PL_EXPORT', projectId);
};
